'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidSync = function IoAndroidSync(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 7.3c6.9 0 12.5 5.7 12.5 12.7 0 2.5-0.7 4.8-2 6.8l-2.2-2.3c0.7-1.4 1.1-2.9 1.1-4.5 0-5.2-4.2-9.5-9.4-9.5v4.7l-6.2-6.4 6.2-6.3v4.8z m0 22.2v-4.7l6.3 6.4-6.3 6.3v-4.8c-6.9 0-12.5-5.7-12.5-12.7 0-2.5 0.7-4.9 2-6.8l2.2 2.3c-0.7 1.4-1.1 2.9-1.1 4.5 0 5.2 4.2 9.5 9.4 9.5z' })
        )
    );
};

exports.default = IoAndroidSync;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-sync.js
// module id = 1944
// module chunks = 0